export default "__VITE_ASSET__G$JUzJsm__"